import { useContext } from 'react'
import { IdeaActionsContext } from './IdeaActionsContextDef'

export function useIdeaActions() {
  const context = useContext(IdeaActionsContext)
  if (!context) {
    throw new Error('useIdeaActions must be used within an IdeaActionsProvider')
  }
  return context
}
